/**
 * Cores registration type code values.
 */
export const CoresRegistrationTypeCodes = {
    individual: 'I',
    business: 'B',
};
